import {isLocalhost} from '../lib/isLocalOrDevEnvironment';

// On localhost the SPA runs on the Vite dev server and calls the API on its own port; everywhere
// else the SPA is served by the API, so relative URLs work.
const baseUrl = isLocalhost ? 'https://localhost:7282' : '';

export default baseUrl;
